import { useHierarchyArea } from '@plarium/hierarchy-react';
import React, { useCallback, useMemo } from 'react';

import { Grid, Select } from '@gogame/components';
import { withFormFieldGroupFormField, FormField } from '@gogame/form';
import { useSourceCache } from '@gogame/hooks-ts';

import {
  FRAUD_PROTECTION_OS_VERSION_OPERATOR,
  FRAUD_PROTECTION_OS_VERSION_MAX_VALUE,
  FRAUD_PROTECTION_OS_VERSION_VALUE,
} from 'scenes/Campaigns/components/Form/FraudProtection/constants';
import {
  loadFraudProtectionOperators,
  loadFraudProtectionOsVersions,
} from 'scenes/Campaigns/sources/fields';

const isRange = (options, id) =>
  options ? options.find((opt) => opt.id === id)?.isRange : false;

export const OsVersion = withFormFieldGroupFormField()(({
  formik,
  name,
  value = {},
  dependencies,
  disabled,
}) => {
  const {
    data: operators,
    loading,
    error,
  } = useHierarchyArea({
    name: FRAUD_PROTECTION_OS_VERSION_OPERATOR,
    source: loadFraudProtectionOperators,
  });
  const loadOsVersions = useSourceCache(loadFraudProtectionOsVersions);
  const operatorId = value?.[FRAUD_PROTECTION_OS_VERSION_OPERATOR];

  const range = useMemo(
    () => isRange(operators, operatorId),
    [operatorId, operators]
  );

  const handleChangeOperator = useCallback(
    (_e, operatorId) => {
      const range = isRange(operators, operatorId);
      const valueClone = { ...value };

      valueClone[FRAUD_PROTECTION_OS_VERSION_OPERATOR] = operatorId;

      if (!range) {
        delete valueClone[FRAUD_PROTECTION_OS_VERSION_MAX_VALUE];
      }

      formik.setFieldValue(name, valueClone);
    },
    [formik.setFieldValue, value, operators]
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Select
          label={'OS version'}
          value={operatorId}
          onChange={handleChangeOperator}
          options={operators}
          loading={loading}
          error={error}
          disabled={disabled}
        />
      </Grid>
      {range ? (
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={6}>
            <FormField.Select
              label={'Min'}
              name={FRAUD_PROTECTION_OS_VERSION_VALUE}
              source={loadOsVersions}
              depends={dependencies[FRAUD_PROTECTION_OS_VERSION_VALUE]}
              padding={'0'}
              withDeselectButton={true}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={6}>
            <FormField.Select
              label={'Max'}
              source={loadOsVersions}
              name={FRAUD_PROTECTION_OS_VERSION_MAX_VALUE}
              depends={dependencies[FRAUD_PROTECTION_OS_VERSION_MAX_VALUE]}
              padding={'0'}
              withDeselectButton={true}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={6}>
          <FormField.Select
            label={'Value'}
            name={FRAUD_PROTECTION_OS_VERSION_VALUE}
            source={loadOsVersions}
            depends={dependencies[FRAUD_PROTECTION_OS_VERSION_VALUE]}
            padding={'0'}
            withDeselectButton={true}
            disabled={disabled}
          />
        </Grid>
      )}
    </Grid>
  );
});
